import { Label, Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconUpload } from "@tabler/icons-react";

interface FileUploadSectionProps {
  selectedFile: File | null;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function FileUploadSection({ selectedFile, handleFileChange }: FileUploadSectionProps) {
  return (
    <div>
      <Label htmlFor="file">
        Document <span className="al-text-red-500">*</span>
      </Label>
      <div className="al-mt-2 al-border-2 al-border-dashed al-border-gray-300 al-rounded-lg al-p-6 al-text-center">
        <input
          id="file"
          type="file"
          accept=".pdf,.docx,.md,.txt"
          onChange={handleFileChange}
          className="al-hidden"
        />
        <label htmlFor="file" className="al-cursor-pointer">
          <Stack direction="column" align="center" gap="sm">
            <IconUpload className="al-w-8 al-h-8 al-text-gray-400" />
            {selectedFile ? (
              <Typography variant="body" weight="medium">
                {selectedFile.name}
              </Typography>
            ) : (
              <>
                <Typography variant="body" weight="medium">
                  Click to upload
                </Typography>
                <Typography variant="body" size="sm" className="al-text-gray-500">
                  PDF, DOCX, MD, or TXT (max 10MB)
                </Typography>
              </>
            )}
          </Stack>
        </label>
      </div>
    </div>
  );
}
